import React, { useEffect, useState } from 'react';
import CalendarUtils from 'services/CalendarUtils';
import moment from 'moment-timezone';
import DefaultTextField from 'components/Utils/DefaultTextField';
import DefaultTimePicker from 'components/Utils/DefaultTimePicker';
import FormHelperText from '@material-ui/core/FormHelperText';

const StaffTimePicker = (props) => {
  const propsValue = props.value || props.field?.value || props.field?.input?.value;

  const [dateStr, setDateStr] = useState('');
  const [dateKey, setDateKey] = useState(1);

  useEffect(() => {
    if (propsValue) setDateStr(CalendarUtils.format(propsValue, 'h:mm A'));
  }, [propsValue]);

  const amPmTime = dateStr.toLowerCase().includes('am') || dateStr.toLowerCase().includes('pm');
  const isValidMilitaryTime = !amPmTime && dateStr.length >= 1 && dateStr.length <= 4;
  const militaryFormat = isValidMilitaryTime
    ? CalendarUtils.formatMilitaryTime(dateStr)
    : undefined;
  const displayLabel =
    (props.label || props.field?.label || 'Time') +
    ' ' +
    (dateStr.length > 0 && !!militaryFormat && dateStr !== militaryFormat ? militaryFormat : '');

  function convertTextToUnix(text) {
    const amPmTime = text.toLowerCase().includes('am') || text.toLowerCase().includes('pm');
    const isValidMilitaryTime = !amPmTime && text.length >= 1 && text.length <= 4;
    if (isValidMilitaryTime) {
      return CalendarUtils.militaryTimeToUnix(moment().unix(), dateStr);
    } else if (amPmTime) {
      return CalendarUtils.convertToTargetTimezone(moment(dateStr, 'h:mm A')).unix();
    }
  }

  function onSubmit() {
    let unix = convertTextToUnix(dateStr);
    changeDate(unix);
    setDateKey(dateKey + 1);
  }

  function onKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSubmit();
    }
  }

  function changeDate(unixDate) {
    if (unixDate) {
      setDateStr(CalendarUtils.format(unixDate, 'h:mm A'));
    } else {
      setDateStr('');
    }
    if (props.field) props.field.input.onChange(unixDate);
    if (props.onChange) props.onChange({}, unixDate);
  }

  function onChangeStr(event) {
    let str = event.target.value;
    setDateStr(str);
  }

  let error = props.field?.meta?.error;

  return (
    <div className="staff-time-picker" style={props.style || props.field?.style}>
      <DefaultTextField
        name="time"
        style={{ width: '100%' }}
        onChange={onChangeStr}
        value={dateStr}
        label={displayLabel}
        onBlur={onSubmit}
        onKeyDown={onKeyDown}
      />
      <DefaultTimePicker
        key={dateKey}
        id="time-picker"
        {...props}
        field={props.field ? { ...props.field, style: {} } : undefined}
        onChange={(event, date) => changeDate(date)}
        small={true}
        style={{}}
        hideError={true}
      />
      {!!error && <FormHelperText>{error}</FormHelperText>}
    </div>
  );
};

export default StaffTimePicker;
